import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar-menu-set" }
const _hoisted_2 = ["id", "onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "my-badge br2 bg-color-danger notification-badge"
}
const _hoisted_5 = {
  key: 1,
  class: "my-badge br2 dot bg-color-notif"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "my-badge br3 bg-color-danger notification-badge"
}

import { ref, onMounted, computed } from 'vue'
import { useNotificationStore } from '@/stores/notificationStore'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarLayout',
  emits: ["app-sidebar-toggled"],
  setup(__props, { emit: __emit }) {

const emit = __emit

// Store de notifications
const notificationStore = useNotificationStore()

// Compteur de messages non lus
const unreadCount = computed(() => notificationStore.unreadMessagesCount)

// Initialisation
onMounted(async () => {
  // Récupérer le compteur initial
  await notificationStore.fetchUnreadCount()

  // Note: Les listeners Socket.IO sont maintenant gérés globalement
  // via socketListenerService.ts, initialisé dans le router
  // Cela permet de recevoir les notifications sur TOUTES les pages

  // Rafraîchir périodiquement (toutes les 60 secondes en fallback)
  setInterval(() => {
    notificationStore.fetchUnreadCount()
  }, 60000)
})

const activeMenu = ref('');
const appMenus: any = [
  {
    icon: '/icons/icon-menu-dashboard.svg',
    url: '/app/dashboard',
    title: 'Dashboard',
    id: 'menu-dashboard',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
  },
  {
    icon: '/icons/icon-menu-collectivite.svg',
    title: 'Collectivités',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    id: 'menu-collectivites',
    children: [
      { url: '/app/collectivites/dashboard', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '/app/collectivites/list', id: 'menu-collectivites-list', title: 'Gestion des collectivités', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/users/list', title: 'Gestion des membres' },
      { url: '/app/collectivites/onboarding', id: 'menu-collectivites-onboarding', title: 'Onboarding', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/prospects/list', title: 'Prospects' },
    ]
  },
  {
    icon: '/icons/icon-menu-carte.svg',
    //url: '/app/components',
    title: 'Carte Coop Finance',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '/app/cartes/form', title: 'Importation de cartes', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/cartes/list', title: 'Suivi des cartes' },
    ]
  },
  {
    icon: '/icons/icon-menu-finance.svg',
    //url: '/app/components',
    title: 'Finance',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '/app/finance/assets', title: 'Assets', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/finance/prelevements', title: 'Prélèvements' },
      { url: '/app/finance/decaissements', title: 'Décaissements', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/finance/transactions', title: 'Transactions' },
      { url: '#', title: 'Rapports financiers' },
    ]
  },
  {
    icon: '/icons/icon-menu-market.svg',
    //url: '/app/components',
    title: 'Market',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'Souscriptions', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/market/market-commandes', title: 'Commandes', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '/app/market/market-categories/list', title: 'Catégories produits' },
      { url: '/app/market/market-produits/list', title: 'Gestion des produits' },
      { url: '/app/market/market-attributs/list', title: 'Gestion des attributs' },
      { url: '/app/market/market-produits-stocks/list', title: 'Gestion du stock' },
      { url: '#', title: 'Gestion des marchands' },
      { url: '/app/market/market-fournisseurs/list', title: 'Gestion des fournisseurs' },
      { url: '#', title: 'Offres promotionnelles' },
      { url: '#', title: 'Livraison et réception de bien' },
      { url: '#', title: 'Service après-vente' },
      { url: '/app/market/market-settings', title: 'Paramètres marketplace' },
    ]
  },
  {
    icon: '/icons/icon-menu-aide.svg',
    //url: '/app/components',
    title: 'Aide et assistance',
    id: 'menu-aide-assistance',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    showUnreadBadge: true, // Afficher le badge de messages non lus
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '/app/service-client', id: 'menu-service-client', title: 'Service client', showUnreadBadge: true },
      { url: '/app/tutorials/list', id: 'menu-tutorials-list', title: 'Tutoriels' },
      { url: '/app/faq/list', id: 'menu-faq-list', title: 'Faq' },
      { url: '/app/categories-aides/list', id: 'menu-categories-aides-list', title: 'Catégories Aides' },
    ]
  },
  {
    icon: '/icons/icon-menu-marketing.svg',
    //url: '/app/components',
    title: 'Marketing digital',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Dashboard', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'Edition des campagnes', badgeIcon: 'my-badge br3 dot bg-color-danger' },
      { url: '#', title: 'Analyse statistique' },
    ]
  },
  {
    icon: '/icons/icon-menu-api.svg',
    //url: '/app/components',
    title: 'API',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'API collectivités', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'API Orange Bank', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
  {
    icon: '/icons/icon-menu-general.svg',
    //url: '/app/components',
    title: 'Général',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Témoignages', badgeIcon: 'my-badge br3 dot bg-color-warning' },
      { url: '#', title: 'Partenaires', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
  {
    icon: '/icons/icon-menu-securite.svg',
    //url: '/app/components',
    title: 'Sécurité',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    id: 'menu-securite',
    children: [
      { url: '/app/admins/list', id: 'menu-admins-list', title: 'Administrateurs', badgeIcon: 'my-badge br3 dot bg-color-warning', permissions: ['admins.read'] },
      { url: '/app/roles/list', id: 'menu-roles-list', title: 'Rôles', badgeIcon: 'my-badge br3 dot bg-color-danger', permissions: ['roles.read'] },
      { url: '/app/permissions/list', id: 'menu-permissions-list', title: 'Permissions', badgeIcon: 'my-badge br3 dot bg-color-danger', permissions: ['permissions.read'] },
    ]
  },
  {
    icon: '/icons/icon-menu-parametre.svg',
    //url: '/app/components',
    title: 'Paramètres',
    badgeIcon: 'my-badge br2 dot bg-color-notif',
    children: [
      { url: '#', title: 'Paramètres', badgeIcon: 'my-badge br3 dot bg-color-danger' },
    ]
  },
];

const appSidebarOpened = ref(true);
function toggleAppSidebar() { 
  appSidebarOpened.value = !appSidebarOpened.value; 
  emit("app-sidebar-toggled", appSidebarOpened.value);
}
function onMenuClick(menuId: string) { 
  if (activeMenu.value === menuId) {
    activeMenu.value = ''; // Désélectionner si déjà actif
    return;
  }
  activeMenu.value = menuId; 
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_hasPermissions = _resolveDirective("hasPermissions")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["sidebar", {'close': !appSidebarOpened.value }])
  }, [
    _createElementVNode("div", {
      class: "sidebar-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAppSidebar()))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "barr1" }, null, -1),
      _createElementVNode("div", { class: "barr2" }, null, -1),
      _createElementVNode("div", { class: "barr3" }, null, -1)
    ]))]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"clear-both\"></div><div class=\"logo-set\"><img src=\"/images/logo.svg\" class=\"logo\"></div><div class=\"user-set\"><div class=\"user-img-set position-relative box-animate rounded\"><img src=\"/assets/users/600w/user11.jpg\" class=\"user-img position-relative\"></div><p class=\"user-info\"><span>Juliette</span><br> Super Admin </p></div><div class=\"clear-both h-5\"></div>", 4)),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appMenus, (menu, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: 'menu_' + index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", {'active': activeMenu.value == 'menu_' + index}])
          }, [
            _createVNode(_component_router_link, {
              to: menu.url ?? '#'
            }, {
              default: _withCtx(() => [
                _createElementVNode("li", {
                  class: _normalizeClass(["sidebar-menu", {'active': activeMenu.value == 'menu_' + index}]),
                  id: menu.id ?? '',
                  onClick: ($event: any) => (onMenuClick('menu_' + index))
                }, [
                  _createElementVNode("img", {
                    src: menu.icon,
                    class: "sidebar-menu-icon",
                    alt: ""
                  }, null, 8, _hoisted_3),
                  _createElementVNode("span", null, _toDisplayString(menu.title), 1),
                  (menu.showUnreadBadge && unreadCount.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(unreadCount.value > 99 ? '99+' : unreadCount.value), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5))
                ], 10, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2),
          (!!menu.children && menu.children.length > 0)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: _normalizeClass(["sidebar-submenu", {'active': activeMenu.value == 'menu_' + index}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (submenu, subindex) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    to: submenu.url,
                    key: 'submenu_' + subindex
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("li", {
                        class: "sidebar-submenu-item",
                        id: submenu.id ?? ''
                      }, [
                        _createTextVNode(_toDisplayString(submenu.title) + " ", 1),
                        (submenu.showUnreadBadge && unreadCount.value > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(unreadCount.value > 99 ? '99+' : unreadCount.value), 1))
                          : (submenu.badgeIcon)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(submenu.badgeIcon)
                              }, null, 2))
                            : _createCommentVNode("", true)
                      ], 8, _hoisted_6)), [
                        [_directive_hasPermissions, submenu.permissions ?? []]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      }), 64)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-20" }, null, -1))
    ])
  ], 2))
}
}

})